import logProviderFactory from './logger/logProviderFactory';

const delay = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

export const reloadFunctiontWithDelayAndRetries = async (
    fn: () => void,
    attempts = 1,
    initialDelayMs = 0,
    retryDelaysMs = 1000,
): Promise<void> => {
    // Wait for the initial delay before the first attempt
    await delay(initialDelayMs);

    for (let attempt = 0; attempt < attempts; attempt++) {
        try {
            await fn();
        } catch (error) {
            logProviderFactory.logError(`Reload function with delay and retry error - ${error}`);
        }

        // Wait for the retry delay before the next attempt, unless it's the last attempt
        if (attempt < attempts - 1) {
            await delay(retryDelaysMs);
        }
    }
};
